.filterHolder {
  position: fixed;
  height: 200px;
  width: 200px;
  z-index: 3000;
  border: 1px solid black;
  border-top-right-radius: 8px;
  border-bottom-left-radius: 8px;
  top: 1px;
  resize: both;
  overflow: auto;
  box-shadow: 4px 4px 4px rgb(64, 64, 64, 0.75);
  min-width: 60px;
  padding: 4px;
  background-color: var(--st-header-background-color);
}

.text {
  overflow-x: hidden;
  overflow-y: visible;
  text-overflow: ellipsis;
  display: flex;
  height: 100%;
  justify-content: center;
}

.clickable {
  cursor: pointer;
  flex-grow: 1;
  overflow-x: hidden;
  text-overflow: ellipsis;
  overflow-y: visible;
}

.clickableDisabled {
  flex-grow: 1;
  overflow-x: hidden;
  text-overflow: ellipsis;
  overflow-y: visible;
}

.iconHolder {
  position: absolute;
  z-index: 9;
  background-color: var(--st-header-background-color);
  right: 4px;
  min-width: max-content;
  display: flex;
  align-items: center;
}
